import fetcher from 'api/fetcher';
import { MagritteNotificationName } from 'utils/constants/notification';

import { urlParser } from '@hh.ru/browser-api-utils';

import { addMagritteNotification } from 'store/models/notification';
import { UserFilterType } from 'store/models/user';
import { UserDetail } from 'store/models/userDetail';
import { setLoadUsers, setUsers } from 'store/models/users';
import { AppThunkAction } from 'store/utils';

export const fetchUsers =
    (isOpenPage = false): AppThunkAction =>
    async (dispatch, getState) => {
        const { filterType, filterValue } = getState().users;

        if (!filterValue && !isOpenPage) {
            dispatch(addMagritteNotification(MagritteNotificationName.UsersPageErrorEmptyValue));
            dispatch(setLoadUsers(false));
            return;
        }

        dispatch(setLoadUsers(true));

        let params: { type?: UserFilterType; value?: string } = {
            type: filterType,
            value: filterValue,
        };

        if (isOpenPage) {
            params = { type: UserFilterType.Empty };
        }

        try {
            const users = await fetcher.get<unknown, UserDetail[]>(
                `/api/v1/backoffice/users/?${urlParser.stringify(params)}`
            );
            dispatch([setUsers(users), setLoadUsers(false)]);
        } catch {
            dispatch(addMagritteNotification(MagritteNotificationName.UsersPageErrorSomethingWentWrong));
            dispatch(setLoadUsers(false));
        }
    };
